import React from 'react'
import { Wifi, WifiOff, Loader2 } from 'lucide-react'
import clsx from 'clsx'

const StatusIndicator = ({ status, label }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'connected':
        return {
          icon: Wifi,
          color: 'text-success-500',
          bgColor: 'bg-success-100',
          dotColor: 'bg-success-500'
        }
      case 'connecting':
        return {
          icon: Loader2,
          color: 'text-warning-500',
          bgColor: 'bg-warning-100',
          dotColor: 'bg-warning-500',
          animate: true
        }
      default:
        return {
          icon: WifiOff,
          color: 'text-error-500',
          bgColor: 'bg-error-100',
          dotColor: 'bg-error-500'
        }
    }
  }

  const config = getStatusConfig()
  const Icon = config.icon

  return (
    <div className="flex items-center space-x-2">
      <div className={clsx(
        'relative flex items-center justify-center w-8 h-8 rounded-full',
        config.bgColor
      )}>
        <Icon className={clsx(
          'w-4 h-4',
          config.color,
          config.animate && 'animate-spin'
        )} />
        
        {/* Status dot */}
        <div className={clsx(
          'absolute -top-1 -right-1 w-3 h-3 rounded-full border-2 border-white',
          config.dotColor,
          status === 'connected' && 'animate-pulse'
        )} />
      </div>
      
      <span className={clsx(
        'text-sm font-medium',
        config.color
      )}>
        {label}
      </span>
    </div>
  )
}

export default StatusIndicator